// extracted by mini-css-extract-plugin
export default {"buttonContainer":"buttonContainer__QqKAr","postButton":"postButton__waESG","caret":"caret__Rzn16"};